import * as consts from "../consts";
import axios from "axios";

function handleError(exception, message, dispatch) {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CARDBUILDER:", exception);
  }
  if (message && dispatch) {
    addAlert(
      {
        message: message,
        type: consts.ALERT_TYPE_ERROR,
      },
      dispatch
    );
  }
}

export function addAlert(alert, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_ADD_ALERT,
      payload: alert,
    });
    resolve();
  });
}

export function dismissAlert(dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_DISMISS_ALERT,
    });
    resolve();
  });
}

export function setBusy(busy, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_BUSY,
      payload: busy,
    });
    resolve();
  });
}

export function setSearching(searching, dispatch) {
  return new Promise((resolve) => {
    dispatch({
      type: consts.ACTION_SET_SEARCHING,
      payload: searching,
    });
    resolve();
  });
}

export function getCategories(dispatch) {
  return new Promise((resolve, reject) => {
    setBusy(true, dispatch);
    axios
      .get(`${consts.SERVICE_URL}/Categories`, {})
      .then((response) => {
        let categories = response.data;
        dispatch({
          type: consts.ACTION_SET_CATEGORIES,
          payload: categories,
        });
        setBusy(false, dispatch);
        resolve(categories);
      })
      .catch((exception) => {
        handleError(
          exception,
          `Unable to retrieve charity categories`,
          dispatch
        );
        setBusy(false, dispatch);
        reject(exception);
      });
  });
}

export function getCharities(filter, charities, dispatch) {
  return new Promise((resolve, reject) => {
    setSearching(true, dispatch);
    if (filter.categoryColumnName || filter.postalCode || filter.query) {
      axios
        .post(
          `${consts.SERVICE_URL}/Charities`,
          {
            ...filter,
            categoryColumnName:
              filter.categoryColumnName != "*" ? filter.categoryColumnName : "",
          },
          {}
        )
        .then((response) => {
          let updatedCharities = [...charities, ...response.data.charities];
          let filteredCharities = updatedCharities.filter(
            (charity, index, array) => {
              return (
                charity.ein &&
                charity.ein.length > 0 &&
                index ==
                  array.findIndex((item) => {
                    return item.ein == charity.ein;
                  })
              );
            }
          );
          let searchResults = {
            charities: filteredCharities,
            filter: {
              ...filter,
              continuationToken: response.data.continuationToken,
            },
            totalCount: response.data.totalCount,
          };
          dispatch({
            type: consts.ACTION_SET_SEARCH_RESULTS,
            payload: searchResults,
          });
          setSearching(false, dispatch);
          resolve(searchResults);
        })
        .catch((exception) => {
          handleError(exception, `Unable to retrieve charities`, dispatch);
          setSearching(false, dispatch);
          reject(exception);
        });
    } else {
      let searchResults = {
        totalCount: -1,
        charities: [],
        filter: {
          query: "",
          postalCode: "",
          categoryColumnName: "",
          continuationToken: null,
        },
      };
      dispatch({
        type: consts.ACTION_SET_SEARCH_RESULTS,
        payload: searchResults,
      });
      setSearching(false, dispatch);
      resolve(searchResults);
    }
  });
}
